import React from "react";

export const CodigoDistribucion = (props) => {
    const { data, codigoDistribucion, codigosDistribucion, seleccionarCodigoDistribucion } = props;

    let codDistId = (codigoDistribucion ? codigoDistribucion.Id : 0);

    const crearSeccionDistribucion = () => {
        return (props.codigosDistribucion || []).map((cd, index) => {
            return <div className="col-xs-4">
                <div className="container-radio radio-margin">
                    <input name="radio-codigo"
                        id={"radio-codigo-gen-" + index}
                        value={cd.Id}
                        type="radio"
                        checked={cd.Id == codDistId}
                        onChange={(event) => {
                            seleccionarCodigoDistribucion(cd.Codigo, event.target.value)
                        }} />
                    <label className="lbl-radio label-secondary"
                        htmlFor={"radio-codigo-gen-" + index}>{cd.Codigo}</label>
                </div>
            </div>
        });
    }

    return (
        <div className="top-separator-xs">
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Código de distribución</label>
                </div>
                {crearSeccionDistribucion()}
                <div>
                    {data.ERROR_CARD["codigoDistribucion"] == false ? <label className="error">Debe seleccionar al menos un código de distribución.</label> : null}
                </div>
            </div>
        </div>
    );
}